<template>
    <v-container>
        <v-dialog v-model="valor">
            <v-card>
                <v-card-title
                    class="text-h5 aviso"
                    style="
                        justify-content: center;
                        background: #1d2735;
                        color: white;
                    "
                >
                    Buscar clientes
                </v-card-title>
                <v-row>
                    <v-col cols="12" md="4">
                        <v-text-field
                            prepend-icon="mdi-account-search"
                            v-model="search"
                            label="Buscar"
                        ></v-text-field>
                    </v-col>
                </v-row>
                <v-data-table
                    dense
                    v-model="selected"
                    show-select
                    :loading="loading"
                    :headers="headers"
                    :server-items-length="total_cliente"
                    :items="Clientes"
                    :search="search"
                    :item-class="getRowClass"
                    :items-per-page="15"
                    item-key="id"
                    class="elevation-1"
                    :sort-by="['nombre']"
                    :sort-desc="[false]"
                    :footer-props="{
                        'items-per-page-options': [10],
                    }"
                    @update:items-per-page="ChangeSize"
                    @pagination="ChangePage"
                >
                    <template v-slot:item.fecha_alta="{ item }">
                        <span>{{ item.fecha_alta | format_date }}</span>
                    </template>
                    <template v-slot:item.action="{ item }">
                        <v-icon
                            @click="detalleCliente(item)"
                            small
                            class="mr-2"
                            color="#1d2735"
                            style="font-size: 25px"
                            title="ver"
                            >mdi-eye-outline</v-icon
                        >
                        <v-icon
                            @click="showAsignar(item)"
                            small
                            class="mr-2"
                            color="#1d2735"
                            style="font-size: 25px"
                            title="Pedir Cliente"
                            >mdi-bell-outline</v-icon
                        >
                    </template>
                </v-data-table>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialog_detalles" max-width="500px">
            <v-card>
                <v-card-title
                    class="text-h5 aviso"
                    style="
                        justify-content: center;
                        background: #1d2735;
                        color: white;
                    "
                >
                    Detalles
                </v-card-title>
                <v-card-text style="text-align: center; padding-top: 1rem">
                    <v-row>
                        <v-col cols="12" md="6">
                            <h4>Nombre fiscal</h4>
                            <p>{{ cliente.razon_social }}</p>
                        </v-col>
                        <v-col cols="12" md="6">
                            <h4>Nombre comercial</h4>
                            <p>{{ cliente.nombre_comercial }}</p>
                        </v-col>

                        <v-col cols="12" md="6">
                            <h4>CIF</h4>
                            <p>{{ cliente.cif }}</p>
                        </v-col>

                        <v-col cols="12" md="6">
                            <h4>Estado</h4>
                            <p>{{ cliente.estado.nombre }}</p>
                        </v-col>
                        <v-col cols="12">
                            <h4>Dirección</h4>
                            <p>{{ cliente.direccion_nombre }}</p>
                        </v-col>
                        <v-col cols="12">
                            <v-data-table
                                :items="agentes"
                                :headers="agente_headers"
                            >
                            </v-data-table>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialog_asig" max-width="500px">
            <v-card>
                <v-card-title
                    class="text-h5 aviso"
                    style="
                        justify-content: center;
                        background: #1d2735;
                        color: white;
                    "
                >
                    Aviso
                </v-card-title>
                <v-card-text style="text-align: center">
                    <h2>
                        ¿Estás seguro que deseas ser asignado a este cliente?
                    </h2>
                </v-card-text>
                <v-card-actions class="pt-3">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="error"
                        large
                        @click="
                            dialog_asig = false;
                            cliente = {};
                        "
                        >Cancelar</v-btn
                    >
                    <v-btn color="success" large @click="AsignarCliente()"
                        >Confirmar</v-btn
                    >
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import { debounce } from "../../../helpers";

export default {
    props: ["value"],

    data() {
        return {
            agentes: [],
            dialog_detalles: false,
            show_busqueda: false,
            filtros: {
                validacion: 0,
            },

            all_selected: false,
            selected: [],
            search: "",
            page: 1,
            loading: false,
            busqueda: "buscar",
            cantidad: 15,
            total_cliente: -1,
            agente_headers: [
                {
                    text: "Nombre",
                    value: "nombre",
                    sortable: false,
                },
                {
                    text: "Nombre del comercial",
                    value: "nombre_comercial",
                    sortable: false,
                },
            ],
            headers: [
                {
                    text: "Nombre del comercial",
                    value: "nombre_comercial",
                    sortable: false,
                },
                {
                    text: "Nombre fiscal",
                    value: "razon_social",
                    sortable: false,
                },
                { text: "CIF", value: "cif", sortable: false },

                { text: "Estado", value: "estado.nombre", sortable: false },

                { text: "Acciones", value: "action", sortable: false },
            ],
            cliente: {
                cif: null,
                razon_social: "",
                nombre_comercial: "",
                direccion: { direccion: "" },
                estado: { nombre: "" },
            },
            Clientes: [],
            selectedItem: 0,
            dialog_comercial: false,
            dialog: false,
            rol: 0,
            valor: this.value,
            dialog_asig: false,
        };
    },
    watch: {
        valor: function (val) {
            this.$emit("input", val);
        },
        value: function (val) {
            this.valor = this.value;
        },
        search: debounce(function (val) {
            this.getClientes();
        }, 500),
    },

    methods: {
        detalleCliente(cliente) {
            this.cliente = cliente;
            let agentes = [];
            cliente.agentes.forEach((element) => {
                if (element.agente_relation != null) {
                    agentes.push(element.agente_relation);
                }
            });
            this.agentes = agentes;
            this.dialog_detalles = true;
        },
        showAsignar(cliente) {
            this.cliente = cliente;

            this.dialog_asig = true;
        },
        AsignarCliente() {
            axios
                .post("api/asignar-cliente", { id: this.cliente.id })
                .then((res) => {
                    this.dialog_asig = false;
                });
        },
        showBusqueda() {
            this.show_busqueda = true;
        },
        getRowClass(item) {
            if (item.revisado == 0) {
                return "row_red";
            }
        },
        downloadFile(response) {
            let blob = new Blob([response.data], { type: "xlsx" }),
                downloadUrl = window.URL.createObjectURL(blob),
                filename = "",
                disposition = response.headers["content-disposition"];

            if (disposition && disposition.indexOf("attachment") !== -1) {
                let filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/,
                    matches = filenameRegex.exec(disposition);

                if (matches != null && matches[1]) {
                    filename = matches[1].replace(/['"]/g, "");
                }
            }

            let a = document.createElement("a");
            if (typeof a.download === "undefined") {
                window.location.href = downloadUrl;
            } else {
                a.href = downloadUrl;
                a.download = filename;
                document.body.appendChild(a);
                a.click();
            }
        },

        ChangeSize(event) {
            this.cantidad = event;
            this.getClientes();
            //console.log(`evento: ${event}`);
        },
        ChangePage(event) {
            this.page = event.page;
            this.getClientes();
            //console.log(event);
        },
        getClientes() {
            this.loading = true;
            axios
                .get(
                    `api/get-clientes/10?page=${this.page}&busqueda=${
                        this.search
                    }&validacion=${
                        this.filtros.validacion ? 1 : 0
                    }&ignore_admin=1`
                )
                .then(
                    (res) => {
                        this.Clientes = res.data.data;
                        this.total_cliente = res.data.total;
                        this.loading = false;
                    },
                    (err) => {
                        this.$custom_error("Error consultando los clientes");
                        this.loading = false;
                    }
                );
        },
    },
};
</script>
<style>
.rowtwo {
    display: flex;
    flex-direction: row;
}
</style>
